import { render, staticRenderFns } from "./PageTen.vue?vue&type=template&id=1b8ac253&scoped=true"
import script from "./PageTen.vue?vue&type=script&lang=js"
export * from "./PageTen.vue?vue&type=script&lang=js"
import style0 from "./PageTen.vue?vue&type=style&index=0&id=1b8ac253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ac253",
  null
  
)

export default component.exports